// extracted by mini-css-extract-plugin
export var actions = "_4k-0";
export var actionsContainer = "_4k-7";
export var border = "_4k-1";
export var childFullHeight = "_4k-f";
export var collapse = "_4k-2";
export var content = "_4k-a";
export var contentChild = "_4k-e";
export var fullscreen = "_4k-c";
export var hasLeftRadius = "_4k-k";
export var headerContainer = "_4k-3";
export var headerRow = "_4k-5";
export var hidePadding = "_4k-b";
export var navCollapsedGap = "_4k-l";
export var noScrollX = "_4k-m";
export var noScrollY = "_4k-n";
export var noTopPadding = "_4k-i";
export var optOutTopPadding = "_4k-d";
export var pageMain = "_4k-j";
export var pageOuter = "_4k-g";
export var pagePadding = "_4k-8";
export var pageScroll = "_4k-9";
export var profile = "_4k-o";
export var profileContainer = "_4k-p";
export var profileImage = "_4k-q";
export var profileMain = "_4k-r";
export var profileSubtitle = "_4k-t";
export var profileTitle = "_4k-s";
export var showLeftPadding = "_4k-h";
export var tabsPortalSlot = "_4k-6";
export var tabsWrapper = "_4k-4";
export var title = "_4k-u";